// extracted by mini-css-extract-plugin
export default {"background-color":"general_background-color__BxMeG"};